<template>
  <div class="specs-info-component">
    <el-form style="padding-bottom:40px;">
      <el-form-item
        label="规格设置"
        label-width="120px"
      >
        <div class="specs-list-box">
          <div class="specs-choose" v-for="(item,index) in ruleList" :key="index">
            <div class="choose-type">
              <el-select v-model="item.id" @change="typeChange($event,item)" :disabled="item.disabled">
                <el-option
                  v-for="(rule,i) in ruleItimList"
                  :key="i"
                  :value="rule.id"
                  :label="rule.name"
                ></el-option>
              </el-select>
              <el-button @click="delRow(item,index)" v-if="dataLength===0">删除</el-button>
            </div>
            <div class="item-box" v-if="item.children.length>0">
              <div class="specs-item" :class="{'active':specs.active,'disabled':specs.disabled}"
                   @click="specsClick(specs,item)" v-for="(specs,index) in item.children" :key="index">
                {{specs.name}}
              </div>
            </div>
          </div>
          <el-select v-model="newType" v-if="ruleList.length<3 && dataLength===0 && specsRow.formType ==='add'"
                     @change="firstChange" style="margin-top: 10px;">
            <el-option
              v-for="(rule,i) in ruleItimList"
              :key="i"
              :value="rule.id"
              :label="rule.name"
            ></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item
        label="批量规格设置"
        label-width="120px"
      >
        <el-select v-model="changeType" @change="typeBatchChange">
          <el-option
            v-for="rule in changeTypeObj"
            :key="rule.prop"
            :value="rule.prop"
            :label="rule.label"
          >
          </el-option>
        </el-select>
        <el-inputNumber v-model="changeValue" :precision="changeValuePrecision"></el-inputNumber>
        <el-button @click="changeSubmit">确定</el-button>
        <div class="cue">重要提示：规格选择完成后再填写信息，填写信息之后选择规格会被清空。</div>
      </el-form-item>
      <el-form-item
        label="规格信息"
        label-width="120px"
      >
        <more-table
          v-if="specsDialog"
          ref="moreTable"
          :tableColumns="column"
          :data="tableData"
          @deleteRow="deleteRow"
          @addImage="addImage"
        >
        </more-table>
      </el-form-item>
    </el-form>
    <div class="btn-box" style="position: absolute;bottom: 10px;width:100%;z-index: 100;">
      <el-button type="primary" @click='submitData'>保存</el-button>
    </div>
  </div>
</template>
<script>
  import specsChoose from "./specsChoose";
  import moreTable from "@/components/business/moreTable";
  import api from "@/config/api";

  export default {
    props: ["specsDialog", "specsRow", 'specsForm'],
    components: {specsChoose, moreTable},
    data() {
      return {
        refresh: false,
        newType: '',
        disabled: false,
        ruleItimList: [],
        dataLength: 0,
        changeValuePrecision: 0,
        changeTypeObj: [
          {
            prop: "buyPrice",
            label: "进价",
            precision: 2,
          },
          {
            prop: "retailPrice",
            label: "零售价",
            precision: 2,
          },
          {
            prop: "vipPrice",
            label: "会员价",
            precision: 2,
          },
          {
            prop: "mallRetailPrice",
            label: "商城零售价",
            precision: 2,
          },
          {
            prop: "mallVipPrice",
            label: "商城会员价",
            precision: 2,
          },
          {
            prop: "mallPlusVipPrice",
            label: "商城Plus会员价",
            precision: 2,
          },
        ],
        changeType: "",
        changeValue: "",
        ruleList: [],
        loading: false,
        sublist: [],
        //表格信息配置
        column: [
          {
            label: "规格名称",
            prop: "specsNameList",
            width: "100",
            align: "center",
          },
          {
            prop: "specsImageUrl",
            label: "规格图片",
            align: "center",
            type: "image",
            width: "100",
          },
          {
            label: "规格条码",
            prop: "specsBarCode",
            align: "center",
            type: "input",
            width: "150",
            disabled: true,
          },
          {
            prop: "buyPrice",
            label: "进价",
            align: "center",
            precision: 2,
            type: "inputNumber",
            width: "150",
          },
          {
            prop: "retailPrice",
            label: "零售价",
            align: "center",
            precision: 2,
            type: "inputNumber",
            width: "150",
          },
          {
            prop: "vipPrice",
            label: "会员价",
            align: "center",
            precision: 2,
            type: "inputNumber",
            width: "150",
          },
          {
            prop: "mallRetailPrice",
            label: "商城零售价",
            align: "center",
            precision: 2,
            type: "inputNumber",
            width: "150",
          },
          {
            prop: "mallVipPrice",
            label: "商城会员价",
            align: "center",
            precision: 2,
            type: "inputNumber",
            width: "150",
          },
          {
            prop: "mallPlusVipPrice",
            label: "商城Plus会员价",
            align: "center",
            precision: 2,
            type: "inputNumber",
            width: "130",
          },
        ],
        tableData: [],
        specsIds: [],
        ruleListSuccess: [],
      };
    },
    mounted() {
      if (this.specsRow.formType === 'edit' && this.specsRow.num === 1) {
        this.getRuleItimList().then((res) => {
          this.getTableData();
        })
      } else {
        this.getRuleItimList()
      }
      if (this.specsForm) {
        this.tableData = this.specsForm.tableData
        this.ruleList = this.specsForm.ruleList
        this.sublist = this.specsForm.sublist
      }
      if (this.tableData.length > 0) {
        this.tableData.map((v, i) => {
          const index = i + 1
          const flag = '-' + (index < 10 ? '0' + index : index)
          if (v.specsBarCode && v.specsBarCode.indexOf('-')) {
            let result = v.specsBarCode.split('-')[0]
            if (result !== this.specsRow.barCode) {
              v.specsBarCode = this.specsRow.barCode + flag
              v.specsArtNo = v.specsArtNo + flag
            }
          }
        })
      }
      // }
    },
    watch: {},
    created() {
    },
    methods: {
      close() {
        this.tableData = [];
        this.ruleList = [];
        this.specsIds = []
        this.dataLength = 0
        this.$emit('submitSuccess');
      },
      //删除行
      deleteRow(index) {
        let item = this.tableData[index];
        if (this.tableData.length === 1 && this.specsRow.formType === 'edit') {
          this.$message.warning('规格商品最少需要一条规格');
          return false;
        }
        if (item.id && this.specsRow.formType === 'edit') {
          this.$confirm('删除规格商品后，此规格商品库存将清除，是否继续?', '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
            this.removeSpecs(index,item);
          }).catch(() => {
          });
        } else {
          this.removeSpecs(index,item);
        }
      },

      removeSpecs(index,item) {
        //当前删除行的子规格
        let specsIdArr = item.specsIdList.split(",");
        //整合出不存在当前删除行的所有子规格
        let tableSpecsIdArr = [];
        for (let i = 0; i < this.tableData.length; i++) {
          if (i !== index) {
            var tableIdArr = this.tableData[i].specsIdList.split(",");
            tableIdArr.map(id => {
              tableSpecsIdArr.push(id);
            })
          }
        }
        //过滤出table中不存在的子规格
        let noExistSpecsId = [];
        specsIdArr.map(id => {
          if (tableSpecsIdArr.indexOf(id) === -1) {
            noExistSpecsId.push(id);
          }
        });

        //修改规格选中编辑状态
        this.ruleList.map(children => {
          if (children.children.length > 0) {
            //遍历循环子规格
            children.children.map(item => {
              if (noExistSpecsId.length > 0) {
                noExistSpecsId.map(id => {
                  if (item.id === parseInt(id)) {
                    item.disabled = false;
                    item.active = false;
                  }
                })
              }
            })
          }
        });
        //根据索引删除元素
        this.tableData.splice(index, 1);
        //根据关联规格id删除数据库数据
        if (item.id) {
          this.$axios.fetchDelete(api.archives.specsMap + '?id=' + item.id).then(res => {
            if (res.code === 200) {
              this.$message({type: 'success', message: '删除成功'});
            } else {
              this.$message({type: 'error', message: '删除失败'});
            }
          });
        }
      },


      //上传照片
      addImage(fileUrl, index) {
        console.log(fileUrl, index)
        this.$set(this.tableData[index], 'specsImageUrl', fileUrl);
      },
      //确定保留几位小数
      typeBatchChange() {
        this.changeValuePrecision = this.changeTypeObj.filter(item => {
          return item.prop == this.changeType
        })[0].precision;
      },

      //批量修改
      changeSubmit() {
        this.tableData.map(item => {
          item[this.changeType] = this.changeValue;
        });
        this.changeType = '';
        this.changeValue = '';
      },

      compare(str1, str2) {
        return str1.split(',').sort().toString() === str2.split(',').sort().toString()
      },

      combination(arr = [], result = []) {
        if (arr.length <= 0) {
          return result
        }
        if (result.length <= 0) {
          result = arr.shift()
          return this.combination(arr, result)
        } else {
          const nextArr = arr.shift()
          const emptyArr = []
          result.specsList.forEach((item) => {
            if (typeof item !== 'object') {
              item = [item]
            }
            nextArr.specsList.forEach((nextItem) => {
              console.log(item.name, nextItem.name)
              emptyArr.push([...item.name, nextItem.name])
            })
          })
          return this.combination(arr, emptyArr)
        }
      },
      // // 删除规格列表中某一项
      // indexOf(arr,val){
      //   for(let i=0;i<arr.length;i++){
      //     if(arr[i].specsIdList == val) return i;
      //   }
      //   return -1;
      // },
      //获取原有规格
      getTableData() {
        this.loading = true
        this.$axios.fetchPost(api.baseInfo.getSpecsList, {goodsId: this.specsRow.id}).then((data) => {
          if (data.code == 200) {
            if (data.data) {
              if (data.data.specsList && data.data.specsIds) {
                this.specsIds = data.data.specsIds;
                this.dataLength = data.data.specsList.length
                data.data.specsList.map(v => {
                  v.active = true
                  v.goodsId = this.specsRow.id
                  v.goodsBrandId = this.specsRow.goodsBrandId
                  v.goodsCategoryId = this.specsRow.goodsCategoryId
                });
                this.tableData = data.data.specsList
              }
              this.$emit('requestSubmit', this.tableData, this.ruleList, this.sublist);
              this.$nextTick(() => {
                this.setRuleList();
              })
            }
          }
        }).finally(() => {
          this.loading = false
        })
      },
      // 进入编辑时 组合
      setRuleList() {
        let array = [];
        Object.keys(this.specsIds).forEach(key => {
          array = array.concat(this.specsIds[key]);
        });
        let ruleParentId = Object.keys(this.specsIds);
        this.$nextTick(() => {
          if (ruleParentId.length > 0) {
            ruleParentId.forEach(v => {
              if (this.ruleItimList.length > 0) {
                let result = this.ruleItimList.filter(item => item.id == v)[0];//已选择的parent
                if (result) {
                  result.children.map(item => {
                    array.forEach(id => {
                      if (id === (String(item.id))) {
                        item.active = true;
                        item.disabled = true
                      }
                    });
                  });
                  this.ruleList.push({
                    id: result.id,
                    name: result.name,
                    disabled: true,
                    children: result.children,
                  })
                  this.sublist.push({
                    id: result.id,
                    specsList: result.children.filter((specs) => {
                      return specs.active == true;
                    }),
                  });
                  console.log(this.ruleList)
                  this.$forceUpdate()
                }
              }
            })
          }
        })

      },
      // 提交
      submitData() {

        // if(!this.specsRow.id){
        //   this.$message.warning('请选择规格')
        // }else if(this.tableData.length ==0){
        //   this.$message.warning('规格信息不能为空')
        // }else{
        //   this.$axios.fetchPost(api.baseInfo.insertSpecsList, {
        //     goodsId: this.specsRow.id,
        //     specsMapList: this.tableData
        //   }).then((data) => {
        //     if (data.code == 200) {
        //       this.$emit('submitSuccess');
        //       this.$message.success("规格设置成功!");
        //     } else {
        //       this.$message.error(data.errorMsg);
        //     }
        //   });
        // }
        // console.log(this.ruleList)
        this.$emit('submitSuccess', this.tableData, this.ruleList, this.sublist);
      },
      // 点击每一个按钮
      specsClick(specs, parent) {
        if (!specs.disabled) {
          specs.active = !specs.active;
          let chooseItem = this.sublist.filter((item) => {
            return item.id === parent.id;
          });
          if (chooseItem.length > 0) {
            chooseItem[0].specsList = parent.children.filter((specs) => {
              return specs.active == true;
            });
          } else {
            this.sublist.push({
              id: parent.id,
              specsList: parent.children.filter((specs) => {
                return specs.active == true;
              }),
            });
          }

          if (this.sublist.length > 0) {
            this.makeUpSpecs(specs);
          }
          //多规格条码改为后端生成
          this.tableData.forEach((v, i) => {
            v.spcesParentId = ('' + v.spcesParentId).split(',').sort().toString()
            v.specsIdList = ('' + v.specsIdList).split(',').sort().toString()
            v.specsNameList = ('' + v.specsNameList).split(',').sort().toString()
            // const index = i + 1
            // const flag = '-' + (index < 10 ? '0' + index : index)
            // v.specsArtNo = this.specsRow.artNo + flag;
            // v.specsBarCode = this.specsRow.barCode + flag;
          })
        }
      },
      //生成规格列表
      makeUpSpecs(specsForm) {
        //数据类型为二维数组，类似[[1,2,3],[4,5],[6,7]],需组合成[146,147,156,157]
        //思路，声名一个临时数组，保存第一个数组，在遍历第二个数组时，遍历临时数组，二者组合成为新的数组，
        //多个数组思路同上
        let tableData = [];
        const targetList = this.$utils.deepClone(this.sublist).filter((v, i) => {
          if (!v.specsList || v.specsList.length <= 0) {
            return false
          }
          return true
        })
        targetList.map((item, index) => {
          if (index == 0) {
            tableData = item.specsList;
          } else {
            let cloneTable = this.$utils.deepClone(tableData);
            tableData = [];
            item.specsList.map((specs) => {
              cloneTable.map((tableItem) => {
                tableData.push({
                  name: tableItem.name + "," + specs.name,
                  id: tableItem.id + "," + specs.id,
                  parentId: tableItem.parentId + "," + specs.parentId,
                });
              });
            });
          }
        });
        this.tableData = this.tableData.filter(v => {
          let flag = false
          tableData = tableData.filter(item => {
            const equal = this.compare(`${item.id}`, `${v.specsIdList}`)
            flag = flag || equal
            return !equal
          })
          if (specsForm && !specsForm.active && v.spcesParentId && v.specsIdList.toString().indexOf(specsForm.id) != -1) {
            return false
          }
          return flag
        })
        // this.tableData = [];
        tableData.map((specs, index) => {
          this.tableData.push({
            goodsId: this.specsRow.id,
            goodsBrandId: this.specsRow.goodsBrandId,
            goodsCategoryId: this.specsRow.goodsCategoryId,
            specsIdList: specs.id,
            specsNameList: specs.name,
            spcesParentId: specs.parentId,
            specsImageUrl: "",
            specsArtNo: '',
            specsBarCode: '',
            buyPrice: this.specsRow.buyPrice,
            vipPrice: this.specsRow.vipPrice,
            retailPrice: this.specsRow.retailPrice,
            plusVipPrice: this.specsRow.plusVipPrice,
            mallRetailPrice: this.specsRow.mallRetailPrice,
            mallVipPrice: this.specsRow.mallVipPrice,
            mallPlusVipPrice: this.specsRow.mallPlusVipPrice,
            specsBase: 0,
            inventoryNum: 0,
            highInventory: 0,
            lowInventory: 0,
          });
        });
      },
      // 新添加
      firstChange(val) {
        let isSelect = this.ruleList.filter(item => item.id === val)
        if (isSelect.length > 0) {
          this.$message.warning('此规格已被选择')
        } else {
          let result = this.ruleItimList.filter(item => item.id === val)[0];
          console.log(result)
          result.children.map(v => {
            v.active = false
          })
          this.ruleList.push({
            id: result.id,
            name: result.name,
            disabled: true,
            children: result.children,
          })
        }
        this.newType = ''
      },
      typeChange(val, item) {
      },
      getRuleItimList() {
        return new Promise((resolve => {
          this.$axios.fetchPost(api.archives.goodsSpecs + '/list', {})
            .then(data => {
              if (data.code == 200 && data.data) {
                this.ruleItimList = this.$utils.dealCascadeData(data.data);
                resolve(this.ruleItimList)
              } else {
                this.$message({message: "请求失败！", type: "error"});
              }
            }).catch(err => {
            this.$message({message: "请求失败！", type: "error"});
          });
        }))
      },
      //删除规格
      delRow(item, index) {
        this.ruleList = this.ruleList.filter(v => {
          return v.id !== item.id
        })
        this.sublist = this.sublist.filter(v => {
          return v.id !== item.id
        })
        this.makeUpSpecs();
        this.tableData.forEach((v, i) => {
          v.spcesParentId = ('' + v.spcesParentId).split(',').sort().toString()
          v.specsIdList = ('' + v.specsIdList).split(',').sort().toString()
          v.specsNameList = ('' + v.specsNameList).split(',').sort().toString()
          const index = i + 1
          const flag = '-' + (index < 10 ? '0' + index : index)
          v.specsArtNo = this.specsRow.artNo + flag;
          v.specsBarCode = this.specsRow.barCode + flag;
        })
      },
    },
  };
</script>
<style>
  .specs-info-component .specs-list-box {
    padding: 0 10px 10px 10px;
    background-color: #eee;
    border-radius: 5px;
    position: relative;
  }

  .specs-info-component .specs-list-box .add-rule-list-btn {
    margin-top: 10px;
  }

  .specs-info-component .el-form-item {
    margin-top: 10px;
  }

  .specs-info-component .cue {
    color: red;
    font-size: 13px;
  }

  .specs-choose {
    /*margin-bottom: 10px;*/
  }

  .specs-choose .choose-type {
    line-height: 30px;
    padding-top: 10px;
  }

  .specs-choose .item-box {
    display: flex;
    flex-direction: row;
  }

  .specs-choose .item-box .specs-item.active {
    border-color: rgb(64, 158, 255);
    color: rgb(64, 158, 255);
  }

  .specs-choose .item-box .specs-item.disabled {
    border-color: rgba(64, 158, 255, .6);
    color: rgba(64, 158, 255, .6);
    background-color: rgba(236, 245, 255, .6);
    cursor: not-allowed;
  }

  .specs-choose .item-box .specs-item {
    width: 120px;
    height: 30px;
    line-height: 30px;
    margin-right: 10px;
    margin-top: 10px;
    background-color: #fff;
    padding: 0 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/business/specsInfo.vue